export default __webpack_public_path__ + "static/media/confetti.51ce0ba2.gif";